import { hsl } from 'polished';
export default {
    global: {
        /** Hex: #073034 */
        black: '#073034',
        /** Hex: #ffffff */
        white: '#ffffff',
    },
    primary: {
        teal: {
            teal100: '#158F9D',
            teal75: '#50ABB5',
            teal50: '#8AC7CE',
            teal25: '#C4E3E6',
            tealBg: '#E2F1F3',
        },
        pear: {
            pear100: '#B9C40A',
            pear75: '#CAD347',
            pear50: '#DCE184',
            pear25: '#EDF0C2',
            pearBg: '#F6F8E0',
        },
        blue: {
            blue100: '#97D5D1',
            blue75: '#B1DFDC',
            blue50: '#CBEAE8',
            blue25: '#E5F4F3',
            blueBg: '#F2FAF9',
        }
    },
    accent: {
        darkBlue: {
            darkBlue100: '#0F5F6B',
            darkBlue75: '#4B8790',
            darkBlue50: '#87AFB5',
            darkBlue25: '#C3D7DA',
            darkBlueBg: '#E1EBED',
        },
        forrestGreen: {
            forrestGreen100: '#3DAB6B',
            forrestGreen75: '#6EC090',
            forrestGreen50: '#9ED5B5',
            forrestGreen25: '#CEEADA',
            forrestGreenBg: '#E7F5ED',
        }
    },
    secondary: {
        purple: {
            purple100: '#922280',
            purple75: '#AD59A0',
            purple50: '#C890BF',
            purple25: '#E4C8DF',
            purpleBg: '#F1E3EF',
        },
        yellow: {
            yellow100: '#EAD235',
            yellow75: '#EFDD68',
            yellow50: '#F4E89A',
            yellow25: '#FAF4CC',
            yellowBg: '#FDF9E5',
        },
        orange: {
            orange100: '#F3824C',
            orange75: '#F6A179',
            orange50: '#F9C0A5',
            orange25: '#FCE0D2',
            orangeBg: '#FDEFE9',
        }
    },
    awards: {
        bronze: {
            bronze100: '#CB8C47',
            bronze75: '#D8A975',
            bronze50: '#E5C5A3',
            bronze25: '#F2E2D1',
            bronzeBg: '#F9F1E8',
        },
        silver: {
            silver100: '#CECECE',
            silver75: '#DADADA',
            silver50: '#E6E6E6',
            silver25: '#F3F3F3',
            silverBg: '#F9F9F9',
        },
        gold: {
            gold100: '#FFC300',
            gold75: '#FFD240',
            gold50: '#FFE180',
            gold25: '#FFF0BF',
            goldBg: '#FFF0BF',
        }
    },
    engagePrimary: {
        green: {
            green100: '#B9C40A',
            green75: '#CAD347',
            green50: '#DCE184',
            green25: '#EDF0C2',
        },
        seaGreen: {
            seaGreen100: '#0F5F6B',
            seaGreen75: '#4B8790',
            seaGreen50: '#87AFB5',
            seaGreen25: '#C3D7DA',
        },
        teal: {
            teal100: '#158F9D',
            teal75: '#50ABB5',
            teal50: '#8AC7CE',
            teal25: '#C4E3E6',
        },
        lime: {
            lime100: '#E9F260',
            lime75: '#EEF588',
            lime50: '#F4F8AF',
            lime25: '#F9FCD7',
        },
        sky: {
            sky100: '#ADE6FF',
            sky75: '#C1ECFF',
            sky50: '#D6F2FF',
            sky25: '#EAF9FF',
        }
    },
    engageSecondary: {
        purple: {
            purple100: '#522E99',
            purple75: '#7D62B2',
            purple50: '#A896CC',
            purple25: '#D4CBE5',
        },
        lilac: {
            lilac100: '#787AFF',
            lilac75: '#9A9BFF',
            lilac50: '#BBBCFF',
            lilac25: '#DDDEFF',
        },
        tangerine: {
            tangerine100: '#FF8F4D',
            tangerine75: '#FFAB7A',
            tangerine50: '#FFC7A6',
            tangerine25: '#FFE3D2',
        },
        lavender: {
            lavender100: '#AA98FF',
            lavender75: '#BFB2FF',
            lavender50: '#D4CBFF',
            lavender25: '#EAE5FF',
        },
        pink: {
            pink100: '#FFB5D6',
            pink75: '#FFC7E0',
            pink50: '#FFDAEA',
            pink25: '#FFECF5',
        },
        yellow: {
            yellow100: '#FFE82E',
            yellow75: '#FFEE62',
            yellow50: '#FFF396',
            yellow25: '#FFF9CB',
        }
    },
    engageNeutral: {
        dusk: '#E2E6FF',
        cream: '#FFFAF2',
    },
    engageGradient: {
        green: `linear-gradient(var(--direction, 180deg), #B9C40A var(--start, 0%), #E9F260 var(--end, 100%))`,
        teal: `linear-gradient(var(--direction, 180deg), #158F9D var(--start, 0%), #ADE6FF var(--end, 100%))`,
        purple: `linear-gradient(var(--direction, 180deg), #522E99 var(--start, 0%), #AA98FF var(--end, 100%))`,
        lilacPink: `linear-gradient(var(--direction, 180deg), #787AFF var(--start, 0%), #FFB5D6 var(--end, 100%))`,
        orangeYellow: `linear-gradient(var(--direction, 180deg), #FF8F4D var(--start, 0%), #FFE82E var(--end, 100%))`,
    },
    validation: {
        /** Hex: #28a745 */
        valid: '#28a745',
        /** Hex: #F03F3F */
        invalid: '#F03F3F',
    },
    grey: {
        grey: '#EFEEEE',
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
export function colourWithTransparency(hexValue, value) {
    const hex = hexValue.replace('#', '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    const rgbValue = `${r}, ${g}, ${b}`;
    return `rgba(${rgbValue}, ${value})`;
}
